'use strict';

import slicks from './../common/slicks';

export default function comparisonSlider() {
    let $mainComparisonSlider = $('.js-comparsion-list');

    if (!$mainComparisonSlider.length) {
        return;
    }

    const SLICK_OPTIONS = {
        arrows: true,
        draggable: false,
        infinite: false,
        slidesToShow: 7,
        responsive: [{
            breakpoint: 1301,
            settings: {
                slidesToShow: 6
            }
        }, {
            breakpoint: 1025,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 992,
            settings: {
                slidesToShow: 4
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 541,
            settings: {
                slidesToShow: 2
            }
        }, {
            breakpoint: 371,
            settings: {
                slidesToShow: 1
            }
        }]
    };

    let $asideComparsionSlider = slicks($('.js-table-slider'), SLICK_OPTIONS);

    slicks($('.js-comparsion-list'), $.extend({}, SLICK_OPTIONS, {
        arrow: false
    })).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
        $asideComparsionSlider.slick('slickGoTo', nextSlide);
    });
}
